import { Library } from "lucide-react";
import type { WorkspaceModel } from "./useWorkspace";
export function SaveToLibrary({ model }: { model: WorkspaceModel }) {
  if (
    !model.canEdit ||
    !model.selected.length ||
    model.selected.some(
      (s) =>
        ["sheet", "trace", "video", "embed", "bookmark"].includes(s.type) ||
        model.editor.isShapeOrAncestorLocked(s),
    )
  )
    return null;
  return (
    <button
      title="Save to My Library"
      aria-label="Save to My Library"
      onClick={() => window.dispatchEvent(new Event("planroom:save-library"))}
    >
      <Library size={16} />
      <span>Save</span>
    </button>
  );
}
